import axios from 'axios'

export const getInsert = function (params) {
	return axios.post('/apis/biz-server/leads/insert', params)
}
//获取行业列表
export const getTradeList = function (params) {
	return axios.post('/apis/biz-server/dict/list', params)
}


//获取省市
export const getAreaList = function (params) {
	return axios.post('/apis/biz-server/area/list', params)
}

//获取人数
export const getCountList = function (params) {
	return axios.get('/apis/biz-server/leads/count', params)
}
//获取广告回调接口
export const advertisersCallback = function (params) {
	return axios.get('/apis/biz-server/leads/wpscallback', {params})
}

//获取短信验证码
export const getCodeFun = function (params) {
	return axios.post('/oauth/sms/send-identity-code', params)
}

//短信验证码验证是否准确
export const getVerifyCode = function (params) {
	return axios.post('/oauth/sms/verify-code', params)
}


// 广告投送数据推送
export const landingPageInsert = function (params) {
	return axios.post('/haip-biz/leads/landingPage/insert', params)
}





// WEBPACK FOOTER //
// ./src/pages/sm/apis.js